import { useState, useEffect } from "react";
import { fetchVilles } from "@/pages/api/authentificationApi";

export const useVilles = () => {
  const [villes, setVilles] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const getVilles = async () => {
    try {
      const villesData = await fetchVilles();
      setVilles(villesData);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("Une erreur est survenue lors du chargement des villes.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVilles();
  }, []);

  return { villes, loading, error };
};
